import React, { FunctionComponent } from 'react';
import { useLocale } from '../../../contexts/LocaleProvider';
import { IntlProvider } from 'react-intl';
import { Box } from '@mui/material';
import SimulationHome from './SimulationHome';
import { useSalesAndResourcesSimulationToolsContent } from '../../../graphql/pimcore/modules/siteContent/hooks/useSalesAndResourcesSimulationToolsContent';

const SimulationPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();
    const { loading, error, contentTree } = useSalesAndResourcesSimulationToolsContent();
    return (
        <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
            <Box
                width="100%"
                component="main"
                sx={{
                    padding: 0,
                    flexGrow: 0,
                    p: 0, // 内边距
                }}
            >
                <SimulationHome cmsContent={contentTree} />
            </Box>
        </IntlProvider>
    );
};

export default SimulationPage;
